import { Link } from "react-router-dom";
import type { KuaibaoItem } from "@/types/kuaibao";
import { formatDateDay, formatHeat } from "@/utils/format";

interface KuaibaoCardProps {
  item: KuaibaoItem;
  index?: number;
}

export default function KuaibaoCard({ item, index }: KuaibaoCardProps) {
  return (
    <article className="group flex flex-col h-full bg-background-50 border border-background-200/80 rounded-lg overflow-hidden hover:border-primary-300 transition-colors">
      <Link to={`/kuaibao/${item.slug}`} className="block w-full h-44 overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 51.cg今日吃瓜单`}
          className="w-full h-44 object-top object-cover group-hover:scale-[1.04] transition-transform duration-500"
        />
      </Link>
      <div className="flex flex-col flex-1 p-4 md:p-5">
        <div className="flex items-center gap-2 mb-3">
          <Link
            to={`/kuaibao?cat=${item.categorySlug}`}
            className="inline-flex items-center px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800 font-label text-xs whitespace-nowrap"
          >
            {item.category}
          </Link>
          {typeof index === "number" && (
            <span className="font-label text-xs text-foreground-400">
              第 {String(index + 1).padStart(2, "0")} 条
            </span>
          )}
        </div>
        <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug mb-2 line-clamp-2">
          <Link to={`/kuaibao/${item.slug}`} className="hover:text-primary-600 transition-colors">
            {item.title}
          </Link>
        </h3>
        <p className="font-label text-sm text-foreground-600 leading-relaxed line-clamp-3 flex-1">
          {item.summary}
        </p>
        <div className="mt-4 pt-3 border-t border-background-200/80 flex items-center justify-between font-label text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1">
            <i className="ri-fire-line text-primary-500 leading-none"></i>
            热度 {formatHeat(item.heat)}
          </span>
          <span>{formatDateDay(item.publishedAt)}</span>
        </div>
      </div>
    </article>
  );
}